import React from 'react';

import BookEntries from '../BookEntries';

const DailyBook: React.FC = () => {
  return (
    <BookEntries
      isTransactional={false}
      allowEditing={true}
      title="Libro Diario"
    />
  );
};

export default DailyBook;
